import { render, staticRenderFns } from "./EcomAdmin.vue?vue&type=template&id=cade36ca&scoped=true"
import script from "./EcomAdmin.vue?vue&type=script&lang=js"
export * from "./EcomAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cade36ca",
  null
  
)

export default component.exports